import { apiClient, toCamelCase, toSnakeCase } from "./client";
import type { Need, NeedCreate, NeedUpdate, NeedListResponse, PaginatedParams } from "@/types";

interface NeedParams extends PaginatedParams {
  state?: string;
  categoryId?: number;
  myNeedsOnly?: boolean;
  endDateFrom?: string;
  endDateTo?: string;
  expediente?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const needsApi = {
  getAll: async (params?: NeedParams): Promise<NeedListResponse> => {
    const response = await apiClient.get("/needs", {
      params: toSnakeCase(params),
    });
    return (toCamelCase(response.data) as NeedListResponse) || { items: [], total: 0 };
  },

  getById: async (id: number): Promise<Need> => {
    const response = await apiClient.get(`/needs/${id}`);
    return toCamelCase(response.data) as Need;
  },

  create: async (data: NeedCreate): Promise<Need> => {
    const response = await apiClient.post("/needs", toSnakeCase(data));
    return toCamelCase(response.data) as Need;
  },

  update: async (id: number, data: NeedUpdate): Promise<Need> => {
    const response = await apiClient.put(`/needs/${id}`, toSnakeCase(data));
    return toCamelCase(response.data) as Need;
  },

  updateState: async (id: number, state: string): Promise<Need> => {
    const response = await apiClient.put(`/needs/${id}/state`, { state });
    return toCamelCase(response.data) as Need;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/needs/${id}`);
  },

  uploadInitialFile: async (id: number, file: File): Promise<Need> => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await apiClient.post(`/needs/${id}/initial-file`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return toCamelCase(response.data) as Need;
  },

  uploadSignature: async (id: number, signType: 1 | 2, file: File): Promise<Need> => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await apiClient.post(`/needs/${id}/sign/${signType}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return toCamelCase(response.data) as Need;
  },

  deleteInitialFile: async (id: number): Promise<void> => {
    await apiClient.delete(`/needs/${id}/initial-file`);
  },
};
